import React from 'react'
import JobCard from './JobCard'
import type { EventListProps } from './EventList'
import type { PainterScheduleEvent } from './types'

interface EventListJobProps extends EventListProps {
  event: PainterScheduleEvent
}

export default function EventListJob(props: EventListJobProps) {
  const {
    event,
    expandedJobId,
    activeTabs,
    expandedCrewNotes,
    expandedProducts,
    onSetExpandedJobId,
    onSetTab,
    onToggleCrewNote,
    onToggleProducts
  } = props
  const canAddAdditionalWork = props.canAddAdditionalWork && !!event.sourceQuote
  return (
    <JobCard
      {...props}
      canAddAdditionalWork={canAddAdditionalWork}
      event={event}
      isExpanded={expandedJobId === event.id}
      activeTab={activeTabs[event.id] ?? 'workOrder'}
      crewNoteExpanded={expandedCrewNotes.has(event.id)}
      productsExpanded={expandedProducts.has(event.id)}
      onToggleExpanded={() => onSetExpandedJobId(expandedJobId === event.id ? false : event.id)}
      onSetTab={(tab) => onSetTab(event.id, tab)}
      onToggleCrewNote={() => onToggleCrewNote(event.id)}
      onToggleProducts={() => onToggleProducts(event.id)}
    />
  )
}
